import rpc from "@/rpc";

class LoanService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    getLoan(id) {
        return this.rpc.execute('getLoan', {
            id: parseInt(id)
        });
    }

    closeLoan(id, bureau) {
        return this.rpc.execute('closeLoan', {
            id: parseInt(id),
            bureau: bureau
        });
    }

    closeLoans(ids, bureau) {
        return this.rpc.execute('closeLoans', {
            ids: ids.map(id => parseInt(id)),
            bureau: bureau
        });
    }

    resendLoans(subjects, bureau, isResend, isOnlyRejected, fromDate = null, subjectType = null, eventTypes = [], issueEventDate = null) {
        return this.rpc.execute('resendLoanToBKI', {
            subjects: subjects,
            bureau: bureau,
            isResend: isResend,
            fromDate: fromDate,
            subjectType: subjectType,
            isOnlyRejected: isOnlyRejected,
            eventTypes: eventTypes,
            issueEventDate: issueEventDate
        });
    }

    checkSendStops(subjects, subjectType = null) {
        return this.rpc.execute('checkSendStops', {
            subjects: subjects,
            subjectType: subjectType
        });
    }

    resendEvents(eventIds, bureau) {
        return this.rpc.execute('resendEvents', {
            eventIds: eventIds,
            bureau: bureau
        });
    }
}

export default new LoanService(rpc)
